"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const legal_documents_1 = __importDefault(require("@phishtool/legal-documents"));
const legal_1 = __importDefault(require("~components/legal"));
const PrivacyPolicy = () => (0, jsx_runtime_1.jsx)(legal_1.default, { heading: "Privacy Policy", content: legal_documents_1.default.privacyPolicy });
exports.default = PrivacyPolicy;
